import type { MovementPattern } from "@heraion/shared";
import type { TFn } from "./i18nTypes";

// Localised movement-pattern label. Reuses the `catalog.pattern_*` keys
// (shipped in all five locales) — the ONE place that maps a MovementPattern to
// its display string. Hoisted 2026-07-07 (AP-1b) from three inline copies
// (WeeklyTargetsCard, E1RMTrendsPanel, MovementBalancePanel) so a fourth
// consumer (the weekly-targets editor) doesn't add a fifth copy.

export const patternLabel = (t: TFn, pattern: MovementPattern): string =>
  t(`catalog.pattern_${pattern}`, { defaultValue: pattern });
